/*
 * Product page: option selectors, price / stock / Klarna updates and the
 * thumbnail gallery. Replaces Shopify's retired option_selection.js.
 */
(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initSection(section) {
    var dataEl = section.parentNode.querySelector('script[id^="ProductJson-"]');
    if (!dataEl) return;
    var data = JSON.parse(dataEl.textContent);

    var optionSelects = section.querySelectorAll('.single-option-selector');
    var idSelect = section.querySelector('#ProductSelect');
    var price = section.querySelector('#product-price');
    var compare = section.querySelector('#ComparePrice');
    var stock = section.querySelector('#product-stock');
    var addButton = section.querySelector('#AddToCart');
    var klarna = section.querySelector('klarna-placement');

    function currentOptions() {
      return Array.prototype.map.call(optionSelects, function (s) { return s.value; });
    }

    function findVariant(options) {
      return data.variants.find(function (v) {
        return v.options.every(function (value, i) { return value === options[i]; });
      });
    }

    function update(variant) {
      if (!variant) {
        if (addButton) { addButton.disabled = true; addButton.style.display = 'none'; }
        if (stock) stock.textContent = 'unavailable';
        return;
      }
      if (idSelect) idSelect.value = String(variant.id);
      if (price) price.innerHTML = formatMoney(variant.price, data.moneyFormat);
      if (compare) compare.innerHTML = variant.compare_at_price > variant.price ? formatMoney(variant.compare_at_price, data.moneyFormat) : '';
      if (stock) {
        if (!variant.available) stock.textContent = 'out of stock';
        else if (variant.tracked && variant.inventory_quantity > 0) stock.textContent = variant.inventory_quantity + ' in stock';
        else stock.textContent = '';
      }
      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.style.display = variant.available ? '' : 'none';
      }
      if (klarna) {
        klarna.setAttribute('data-purchase-amount', String(variant.price));
        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      }
      if (variant.media_id) showMedia(variant.media_id);

      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    Array.prototype.forEach.call(optionSelects, function (select) {
      select.addEventListener('change', function () {
        update(findVariant(currentOptions()));
      });
    });

    // Thumbnails
    var mainImage = section.querySelector('#ProductPhotoImg');
    var thumbs = section.querySelectorAll('.product-single__thumb');

    function showMedia(mediaId) {
      var thumb = section.querySelector('.product-single__thumb[data-media-id="' + mediaId + '"]');
      if (thumb) selectThumb(thumb);
    }

    function selectThumb(thumb) {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute('data-src');
      mainImage.srcset = thumb.getAttribute('data-srcset');
      mainImage.alt = thumb.getAttribute('data-alt') || '';
      mainImage.setAttribute('data-image-id', thumb.getAttribute('data-media-id'));
      Array.prototype.forEach.call(thumbs, function (t) { t.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
    }

    Array.prototype.forEach.call(thumbs, function (thumb) {
      thumb.addEventListener('click', function () { selectThumb(thumb); });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-product-section]');
    if (section) initSection(section);
  });
})();
